import React, { Component } from 'react'
import {NavLink} from "react-router-dom";
import ReactTable from "react-table";
import SostaOnlineApiService from "../../../../services/SostaOnlineApiService";
import moment from 'moment'

const columns = [
    {
        Header: 'ID',
        accessor: 'id',
        filterable: true,
        sortable: false,
        width: 80,
        Cell: (row) => {
            if (!row.value) {
                return null
            }
            return (<div>{row.value}</div>)
        }
    },
    {
        Header: 'Categorie abilitate',
        accessor: 'Categories',
        filterable: false,
        sortable: false,
        Cell: (row) => {
            if (!row.value) {
                return null
            }
            return (
              <div>
                  {row.value.map((item, index) => {
                      let string = item.name
                      if (index < row.value.length - 1) {
                          string = string + ', '
                      }
                      return string
                  })}
              </div>
            )
        }
    },
    {
        Header: 'Validità Lista di Attesa',
        accessor: '',
        filterable: false,
        sortable: false,
        Cell: (row) => {
            if (!row.original.startDate || !row.original.startDate) {
                return null
            }
            const startDate = moment(row.original.startDate).format('L HH:mm')
            const endDate = moment(row.original.endDate).format('L HH:mm')
            return (
              <div>
                  {`${startDate} - ${endDate}`}
              </div>
            )
        }
    },
    {
        Header: 'Tipo di abbonamento',
        accessor: 'parkTicketType',
        filterable: false,
        sortable: false,
        Cell: (row) => {
            if (!row.value) {
                return null
            }
            return (<div>{row.value.name}</div>)
        }
    },
    {
        Header: 'Validità Abbonamento',
        accessor: '',
        filterable: false,
        sortable: false,
        Cell: (row) => {
            if (!row.original.startDate || !row.original.startDate) {
                return null
            }
            const startDate = moment(row.original.markStartDate).startOf('month').format('L')
            const numberOfMonths = row.original.numberOfMonths
            const endDate = moment(row.original.markStartDate).add(numberOfMonths - 1, 'months').endOf('month').format('L')

            return (
              <div>
                  {`${startDate} - ${endDate}`}
              </div>
            )
        }
    },
    {
        Header: 'Partecipanti',
        accessor: '',
        filterable: false,
        sortable: false,
        Cell: (row) => {
            const availabilityNumber = row.original.availabilityNumber
            return (
              <div>
                  {`${row.original.subscriptions}/${availabilityNumber}`}
              </div>
            )
        }
    },
    {
        Header: 'Stato',
        accessor: 'status',
        filterable: false,
        sortable: false,
        Cell: (row) => {
            if (!row.value) {
                return null
            }
            if (row.value === 'open') {
                return (
                  <div className="text-success">Attiva</div>
                )
            }

            if (row.value === 'closed') {
                return (
                  <div className="text-danger">Chiusa</div>
                )
            }
        }
    },
]

export default class List extends Component {
    constructor (props) {
        super(props)

        this.state = {
            waitingLists: [],
            pagination: {
                total: 0,
                limit: 100,
                offset: 0
            },
            filters: {}
        }
    }

    componentDidMount () {
        this.setState({loading: true})
        this.fetchWaitingLists()
    }

    onCreateWaitingListClick = () => {
        this.props.history.push('/backoffice/waiting-lists/create')
    }

    fetchWaitingLists = (filterObj, limit, offset) => {
        this.setState({loading: true})
        let string = ''
        for (let key in filterObj) {
            string = string + key + '=' + filterObj[key] + '&'
        }
        console.log(filterObj)

        SostaOnlineApiService.fetchWaitingLists(string, limit || 100, offset || 0).then((data) => {
            this.setState({
                waitingLists: data.data,
                pagination: data.pagination,
                loading: false
            })
        })
    }

    onFetchData = (state, instance) => {
        let filterObj = {}
        for (let i in state.filtered) {
            let f = state.filtered[i]
            if (typeof f.value === 'string') {
                filterObj[f.id] = f.value
            }
        }

        let sortObj = {}
        for (let i in state.sorted) {
            let s = state.sorted[i]
            sortObj[s.id] = s.desc ? 'desc' : 'asc'
        }

        this.fetchWaitingLists(filterObj, state.pageSize, state.page)
    }

    handleFilterChange = (filter) => {
        let newFilters = Object.assign({}, this.state.filters)
        if (filter.filterTerm) {
            newFilters[filter.column.key] = filter
        } else {
            delete newFilters[filter.column.key]
        }
        this.setState({ filters: newFilters })
    }

    onRowClick = (rowIdx, row) => {
        if (rowIdx <= -1 || !row) {
            return
        }

        this.props.history.push('/backoffice/users/' + row.id)
    }

    onClearFilters = () => {
        // all filters removed
        this.setState({filters: {} })
    }

    getTotalPages = () => {
        const {pagination} = this.state

        if (!pagination) {
            return 0
        }

        if (pagination.total === 0) {
            return 0
        }

        return Math.ceil(pagination.total / pagination.limit)
    }

    render () {
        return (
          <div>
              <div className="btn-group">
                  <div className="btn-group" role="group">
                      <button type="button" className="btn btn-add" onClick={this.onCreateWaitingListClick}>
                          <i className="glyphicon glyphicon-plus">{}</i> Lista di Attesa
                      </button>
                  </div>
              </div>

              <ReactTable
                getTdProps={(state, rowInfo, column, instance) => {
                    return {
                        onClick: (e, handleOriginal) => {
                            if (!rowInfo) {
                                return
                            }
                            console.log(rowInfo)
                            this.props.history.push('/backoffice/waiting-lists/' + rowInfo.original.id)
                        }
                    }
                }}
                manual
                filterable
                loading={this.props.loading}
                noDataText="Nessuna Lista d'Attesa Presente"
                onFetchData={this.onFetchData}
                pages={this.getTotalPages()}
                className="-highlight"
                data={this.state.waitingLists ? this.state.waitingLists : []}
                style={{maxHeight: '500px'}}
                defaultPageSize={100}
                nextText="Avanti"
                previousText="Indietro"
                loadingText="Caricamento in corso..."
                rowsText="elementi"
                ofText="di"
                pageText="Pagina"
                columns={columns}
              />
          </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/containers/Backoffice/BackofficeWaitingList/List/List.js